// extracted by mini-css-extract-plugin
export default {"container":"emergencies-table_container__aJEd1"};